var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailSharp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A8AAF45-0ADA-4DA4-88DF-19056AA944CE_sharp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.7877713%",
    y1: "80.2864889%",
    x2: "100%",
    y2: "31.4257407%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003DA5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 630,
    height: 353,
    rx: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.2%",
    y: "-5.9%",
    width: "110.5%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.29914253   0 0 0 0 0.575556979   0 0 0 0 1  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logins---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[New]-Customer-Portal---Desktop---Logins---Forgot-ID---Error---Help",
    transform: "translate(-590.000000, -604.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F8FA",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "illustration_login",
    transform: "translate(104.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(8.000000, 45.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.799999952
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.965305,319.061342 C491.797275,276.330591 502.479261,189.172784 460.96518,128.509657 C426.329651,77.9435887 362.642358,26.0043205 282.284694,10.8183448 C201.927029,-4.367631 131.603958,-4.28685454 101.176483,15.6649328 C76.2518503,32.0625555 87.8240014,54.8415192 95.6736423,74.2278712 C106.112856,100.076341 107.650414,120.67434 64.7606234,158.235397 C15.8015227,201.127701 2.52996485,217.282994 0.102240845,258.802098 C-1.92086249,292.566661 26.32166,337.963035 63.3849131,344.505929 C114.933586,353.552893 134.112606,329.643059 184.528341,313.487766 C224.990407,300.563531 253.071082,306.621766 289.810638,331.420142 C326.550195,356.218517 381.254909,381.663104 446.965305,319.061342 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "login_page_illustration_2",
    transform: "translate(63.000000, 90.000000)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.799999952,
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(405.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Agent",
    transform: "translate(185.000000, 213.000000)",
    fill: "#0A1F44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone-No.-Copy",
    transform: "translate(0.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-mail",
    transform: "translate(2.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1742416,0 C19.1814646,0 20,0.794569186 20,1.77241756 L20,13.2262887 C19.9997778,14.2034902 19.1814646,15 18.1740193,15 L1.82686965,15 C0.818535393,15 0,14.2034902 0,13.2262887 L0,1.77241756 C0,0.794569186 0.818535393,0 1.82686965,0 L18.1742416,0 Z M1.828,3.116 L1.83931548,13.2265043 L18.1597955,13.2146451 L18.159,3.127 L10.5857246,9.77585665 C10.4158966,9.92444606 10.2073512,10 9.9988059,10 C9.79026056,10 9.58171522,9.92444606 9.41166717,9.77585665 L1.828,3.116 Z M16.876,1.773 L3.134,1.784 L9.99902589,7.8142017 L16.876,1.773 Z",
    id: "Combined-Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSharp);
export default __webpack_public_path__ + "static/media/Mail_sharp.923d7fae7dd47f05f28d1a20e960e717.svg";
export { ForwardRef as ReactComponent };